// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3VLDw","unreadBadge":"styles_unreadBadge__359hr","modalContent":"styles_modalContent__OGeVF","modal":"styles_modal__2IHHc"};